export default "https://cdn.questicon.mathletics.com/assets/images/close-icon-25cfef420129801d3984981ea4d56823.svg";